import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { IntegrityInfo, CsumStatus, PassportReaderServiceState } from '../../service/hw-service-model';
import { PassportReaderService } from '../../service/passport-reader.service';

declare function PLATFORM_DEVICE_PARAM(args: string, callback?: (r: string) => void): any;

@Component({
  selector: 'info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  providers: [PassportReaderService],
})
export class InfoComponent implements OnInit {
  sysVersion: string;
  network: any[];
  diskInfo: any[];
  uptime: any[];
  certs: any[];
  packages: any = '';
  time: Date = new Date();

  integrityInfo: IntegrityInfo | undefined = undefined;
  @Input() integrityInfo$: Observable<null | number | IntegrityInfo>;

  @Input() appName: string;
  @Input() appVersion: string;
  @Input() appVersionDecl: string;

  csumsStatus = CsumStatus;

  private interval: any;

  constructor(private cdr: ChangeDetectorRef, private passportReaderService: PassportReaderService) {
    PLATFORM_DEVICE_PARAM('packages', (r: string) => {
      this.packages = r;
      this.cdr.detectChanges();
    });

    this.passportReaderService.connectionState$.subscribe((state) => {
      if (state == PassportReaderServiceState.Ready) {
        concat(
          this.passportReaderService.EnumCvCerts('CVCA'),
          this.passportReaderService.EnumCvCerts('DVCA'),
          this.passportReaderService.EnumCvCerts('Terminal'),
        ).subscribe((certs) => {
          certs.forEach((cert, ix) => {
            cert.isLink = cert.CAR !== cert.CHR;
            certs[ix] = cert;
          });
          this.certs = this.certs ? this.certs.concat(certs) : certs;
          this.cdr.detectChanges();
        });
      }
    });
    this.passportReaderService.connect();
  }

  ngOnInit(): void {
    this.network = this.GET_NETWORKS();
    this.uptime = this.GET_UPTIME();
    this.sysVersion = PLATFORM_DEVICE_PARAM('sys_version');
    this.diskInfo = PLATFORM_DEVICE_PARAM('diskInfo');
    this.interval = setInterval(() => {
      this.time = new Date();
    }, 1000);
    this.integrityInfo$?.subscribe((info) => (this.integrityInfo = info instanceof IntegrityInfo ? (info as IntegrityInfo) : undefined));
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  GET_UPTIME() {
    let uptimeS = PLATFORM_DEVICE_PARAM('uptime');
    return [(uptimeS / 3600).toFixed(0), Math.floor((uptimeS % 3600) / 60).toFixed(0)];
  }

  GET_NETWORKS() {
    let NETWORKS = [];
    let GetNetwork = PLATFORM_DEVICE_PARAM('networkInterfaces');
    for (let i = 0; i < Object.keys(GetNetwork).length; i++) {
      let NetworkElements = {
        name: Object.keys(GetNetwork)[i],
        param: this.findNetworkParam(i, GetNetwork),
      };
      NETWORKS.push(NetworkElements);
    }
    return NETWORKS;
  }

  findNetworkParam(i: number, GetNetwork: any[]): any {
    let ResArr: any[] = [];
    Object.values(GetNetwork)[i].forEach((element: any) => {
      if (element.family == 'IPv4') ResArr.push([element.address, element.mac]);
    });
    return ResArr;
  }

  isIntegrityError(message: string) {
    return !['Учётный номер устройства:', 'Дата инициализации устройства:', 'Серийный номер процессора:', 'Контрольные суммы верны.'].find(
      (validMsg) => message.startsWith(validMsg),
    );
  }

  isCertValid(cert: any): boolean {
    return cert['effective-date'] < new Date() < cert['expiration-date'];
  }
}
